(() => {
  'use strict';
  if (window.PinmeMoonlitSignup) return;
  const controllers = new Map();
  const selector = '[data-moonlit-native-signup]';
  const storagePrefix = 'pinme.moonlit.signup.pending.v2:';
  const pendingLifetime = 10 * 60 * 1000;
  const analyticsPrefix = 'pinme.moonlit.signup.analytics.v1:';
  const analyticsLifetime = 15 * 60 * 1000;
  const analyticsReceipts = new Map();
  const analyticsFlights = new Map();
  const analyticsEndpoint = 'https://pinme-community-service.gudaoa9261.chatgpt.site';
  const analyticsRetryDelays = [1000, 3000, 10000, 30000];
  let analyticsRefusalEpoch = 0;
  let analyticsTimer = null, analyticsTicks = 0, privacyLoading = false;
  const returnParameter = 'mn_signup';
  // Only this verified former main theme may recover records written before
  // pending records carried their environment. Draft theme IDs are excluded.
  const legacyMainThemes = new Set(['191826296905']);
  const previewParameters = ['preview_theme_id', 'preview_key', '_fd', '_ab'];
  const roots = scope => [...(scope.matches?.(selector) ? [scope] : []), ...scope.querySelectorAll(selector)];
  const decodeMessage = value => String(value || '').replace(/&(?:#(\d+)|#x([\da-f]+)|(amp|apos|quot|lt|gt|nbsp));/gi, (entity, decimal, hex, named) => {
    if (named) return { amp: '&', apos: "'", quot: '\"', lt: '<', gt: '>', nbsp: '\u00a0' }[named.toLowerCase()];
    const code = parseInt(decimal || hex, hex ? 16 : 10);
    return code > 0 && code <= 0x10ffff && !(code >= 0xd800 && code <= 0xdfff) ? String.fromCodePoint(code) : entity;
  });
  const themeIdentity = () => String(window.Shopify?.theme?.id || '');
  const productionPage = () => window.Shopify?.theme?.role === 'main' && !window.Shopify?.designMode && location.protocol === 'https:' && ['pinmetoys.com','www.pinmetoys.com'].includes(location.hostname) && !previewParameters.some(name => new URL(location.href).searchParams.has(name));
  const pendingEnvironment = () => ({ themeRole: String(window.Shopify?.theme?.role || ''), environment: productionPage() ? 'production' : 'preview', origin: location.origin });
  function analyticsPermission() {
    try {
      const privacy = window.Shopify?.customerPrivacy;
      if (typeof privacy?.analyticsProcessingAllowed !== 'function') return null;
      const value = privacy.analyticsProcessingAllowed();
      return value === true ? true : value === false ? false : null;
    } catch (_) { return null; }
  }
  const analyticsAllowed = () => analyticsPermission() === true;
  function signedSignupContext(value) {
    if (!value || !['moonlit-offers-v1', 'moonlit-price-v2'].includes(value.experimentId) || value.analyticsConsent !== true || typeof value.token !== 'string') return null;
    const match = /^v1\.([a-f0-9-]{36})\.(\d{10})\.(\d{10})\.([a-f0-9]{64})$/.exec(value.token);
    const now = Date.now() / 1000;
    if (!match || Number(match[2]) > now + 60 || Number(match[3]) <= now || Number(match[3]) - Number(match[2]) !== 86400) return null;
    const visitId = typeof value.visitId === 'string' && /^[a-f0-9]{8}-[a-f0-9]{4}-4[a-f0-9]{3}-[89ab][a-f0-9]{3}-[a-f0-9]{12}$/i.test(value.visitId) ? value.visitId : null;
    return { experimentId:value.experimentId, token:value.token, analyticsConsent:true, ...(visitId ? {visitId} : {}) };
  }
  function assignmentIntent(allowUnknown = false) {
    const value = window.PinmeMoonlitExperiment;
    const permission = analyticsPermission();
    if (!productionPage() || permission === false || (!allowUnknown && permission !== true) || !value || !['moonlit-offers-v1','moonlit-price-v2'].includes(value.experimentId) || !['A','B'].includes(value.variant) || value.environment !== 'production' || value.themeId !== themeIdentity() || value.country !== 'US' || value.currency !== 'USD' || value.forced || !value.storageAvailable || !Number.isFinite(value.expiresAt) || value.expiresAt <= Date.now() || value.expiresAt > Date.now() + 30 * 86400000 + 60000) return null;
    return {experimentId:value.experimentId,variant:value.variant,themeId:value.themeId,environment:'production',expiresAt:value.expiresAt};
  }
  function continuesCurrentAssignment(value) {
    const current = assignmentIntent();
    return current && value && Object.keys(current).every(key => current[key] === value[key]);
  }
  function legacySignupContext(value) {
    if (!productionPage() || !analyticsAllowed() || !legacyMainThemes.has(value.themeId) || value.productId !== '15881569534025' || value.view !== 'moonlit-early-bird') return null;
    try {
      const prefix = 'pinme.moonlit.offers.landing.v1.production';
      const assignment = JSON.parse(localStorage.getItem(prefix + '.layout') || 'null');
      const identity = JSON.parse(localStorage.getItem(prefix + '.visitor') || 'null');
      const saved = JSON.parse(localStorage.getItem(prefix + '.token.' + value.themeId) || 'null');
      const now = Date.now();
      if (!assignment || assignment.version !== 1 || !identity || !saved || !['A','B'].includes(assignment.variant) || assignment.variant !== identity.variant || identity.variant !== saved.variant || !/^[a-f0-9]{8}-[a-f0-9]{4}-4[a-f0-9]{3}-[89ab][a-f0-9]{3}-[a-f0-9]{12}$/i.test(identity.visitorId || '') || identity.visitorId !== saved.visitorId || !Number.isFinite(identity.expiresAt) || identity.expiresAt !== assignment.expiresAt || identity.expiresAt <= now || identity.expiresAt > now + 30 * 86400000 + 60000 || saved.environment !== 'production' || saved.themeId !== value.themeId || !Number.isFinite(saved.expiresAt) || saved.expiresAt <= now / 1000 || saved.expiresAt > now / 1000 + 86460) return null;
      const context = signedSignupContext({experimentId:'moonlit-offers-v1',token:saved.token,analyticsConsent:true});
      const parts = context?.token.split('.');
      return context && Number(parts[3]) === saved.expiresAt && Number(parts[2]) * 1000 <= value.createdAt + 60000 ? context : null;
    } catch (_) { return null; }
  }
  function pendingSignupContext(value, form) {
    if (!productionPage() || !analyticsAllowed() || value?.analyticsPermissionAtSubmit === false) return null;
    if (!Object.prototype.hasOwnProperty.call(value, 'experimentContext')) return legacySignupContext(value);
    const original = signedSignupContext(value.experimentContext);
    // A signed original owner survives a publication or another active round.
    // Its authoritative owner is verified by the existing backend, never replaced.
    if (original) {
      if (value.experimentAssignment && original.experimentId !== value.experimentAssignment.experimentId) return null;
      return original;
    }
    if (value.experimentContext !== null && !original) return null;
    const stored = storedAssignmentContext(value.experimentAssignment, value.createdAt);
    if (stored) return stored;
    if (!continuesCurrentAssignment(value.experimentAssignment)) return null;
    let current;
    try { current = signedSignupContext(window.PinmeMoonlitExperimentCollector?.signupContext?.(window.PinmeEmailInterests?.config(form), form)); }
    catch (_) { return null; }
    if (current && current.experimentId !== value.experimentAssignment.experimentId) return null;
    return current || undefined;
  }
  function validAssignment(value, allowRecentExpiry = false) {
    return value?.environment === 'production' && /^\d+$/.test(value.themeId || '') &&
      ['moonlit-offers-v1','moonlit-price-v2'].includes(value.experimentId) && ['A','B'].includes(value.variant) &&
      Number.isFinite(value.expiresAt) && value.expiresAt > Date.now() - (allowRecentExpiry ? analyticsLifetime : 0) && value.expiresAt <= Date.now() + 30 * 86400000 + 60000;
  }
  function storedAssignmentContext(assignment, createdAt) {
    if (!validAssignment(assignment, true)) return null;
    try {
      const prefix = assignment.experimentId === 'moonlit-offers-v1' ? 'pinme.moonlit.offers.landing.v1.production' : 'pinme.moonlit.price.landing.v2.production';
      const layout = JSON.parse(localStorage.getItem(prefix + '.layout') || 'null');
      const identity = JSON.parse(localStorage.getItem(prefix + '.visitor') || 'null');
      const saved = JSON.parse(localStorage.getItem(prefix + '.token.' + assignment.themeId) || 'null');
      if (layout?.version !== 1 || layout.variant !== assignment.variant || layout.expiresAt !== assignment.expiresAt || !identity || identity.variant !== assignment.variant || identity.expiresAt !== assignment.expiresAt || !/^[a-f0-9]{8}-[a-f0-9]{4}-4[a-f0-9]{3}-[89ab][a-f0-9]{3}-[a-f0-9]{12}$/i.test(identity.visitorId || '') || saved?.visitorId !== identity.visitorId || saved.variant !== assignment.variant || saved.environment !== 'production' || saved.themeId !== assignment.themeId) return null;
      const context = signedSignupContext({experimentId:assignment.experimentId,token:saved.token,analyticsConsent:true});
      const parts = context?.token.split('.');
      return context && Number(parts[3]) === saved.expiresAt && Number(parts[2]) * 1000 <= createdAt + 60000 ? context : null;
    } catch (_) { return null; }
  }
  function removeAnalyticsReceipt(receiptId) {
    const flight = analyticsFlights.get(receiptId);
    if (flight) { clearTimeout(flight.timeout); flight.controller.abort(); analyticsFlights.delete(receiptId); }
    analyticsReceipts.delete(receiptId);
    try { sessionStorage.removeItem(analyticsPrefix + receiptId); } catch (_) {}
    if (!analyticsReceipts.size && analyticsTimer) { clearTimeout(analyticsTimer); analyticsTimer = null; }
  }
  function validAnalyticsReceipt(value) {
    const original = signedSignupContext(value?.experimentContext);
    return value?.version === 1 && /^[a-f0-9]{8}-[a-f0-9]{4}-4[a-f0-9]{3}-[89ab][a-f0-9]{3}-[a-f0-9]{12}$/i.test(value.receiptId || '') &&
      Number.isFinite(value.createdAt) && value.createdAt <= Date.now() && Date.now() - value.createdAt < analyticsLifetime &&
      value.origin === location.origin && value.environment === 'production' && value.themeRole === 'main' && /^\d+$/.test(value.themeId || '') && value.productId === '15881569534025' &&
      typeof value.path === 'string' && /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/mumuse-moonlit-noir-las-vegas-limited-plush-pendant\/?$/i.test(value.path) && value.view === 'moonlit-early-bird' &&
      typeof value.source === 'string' && value.source.length > 0 && value.source.length <= 160 &&
      typeof value.formId === 'string' && value.formId.startsWith('PinmeMoonlitSignup-') && value.formId.length <= 200 &&
      value.analyticsPermissionAtSubmit !== false && (original ? (!value.assignment || validAssignment(value.assignment, true) && value.assignment.themeId === value.themeId && value.assignment.experimentId === original.experimentId) : value.experimentContext === null && (validAssignment(value.assignment, true) && value.assignment.themeId === value.themeId || value.legacyOwner === true && !value.assignment && legacyMainThemes.has(value.themeId)));
  }
  function restoreAnalyticsReceipts() {
    if (!productionPage()) return;
    try {
      const keys = [...Array(sessionStorage.length)].map((_, i) => sessionStorage.key(i)).filter(k => k?.startsWith(analyticsPrefix));
      for (const key of keys) {
        let value;
        try { value = JSON.parse(sessionStorage.getItem(key) || 'null'); } catch (_) {}
        if (!validAnalyticsReceipt(value) || key !== analyticsPrefix + value.receiptId) { sessionStorage.removeItem(key); continue; }
        if (analyticsReceipts.has(value.receiptId)) continue;
        if (analyticsReceipts.size < 8) analyticsReceipts.set(value.receiptId, value);
        else sessionStorage.removeItem(key);
      }
    } catch (_) {}
  }
  function scheduleAnalyticsRecovery(reset = false) {
    if (reset) analyticsTicks = 0;
    if (analyticsTimer || !analyticsReceipts.size || analyticsTicks >= 12) return;
    const delay = [300, 1000, 3000, 8000][Math.min(analyticsTicks, 3)];
    analyticsTicks++;
    analyticsTimer = setTimeout(() => { analyticsTimer = null; flushAnalyticsReceipts(); }, delay);
  }
  function flushAnalyticsReceipts() {
    if (!productionPage()) return;
    const allowed = analyticsPermission();
    if (allowed === false) {
      for (const id of [...analyticsReceipts.keys()]) removeAnalyticsReceipt(id);
      if (analyticsTimer) clearTimeout(analyticsTimer);
      analyticsTimer = null;
      return;
    }
    for (const [id, value] of analyticsReceipts) if (!validAnalyticsReceipt(value)) removeAnalyticsReceipt(id);
    if (!analyticsReceipts.size) return;
    if (allowed === null) {
      if (!privacyLoading && typeof window.Shopify?.loadFeatures === 'function') {
        privacyLoading = true;
        try { window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.2'}], () => { privacyLoading = false; scheduleAnalyticsRecovery(true); }); }
        catch (_) { privacyLoading = false; }
      }
      scheduleAnalyticsRecovery();
      return;
    }
    for (const [id, value] of analyticsReceipts) {
      if (location.pathname !== value.path || new URL(location.href).searchParams.get('view') !== value.view || analyticsFlights.has(id) || (value.attempts || 0) >= 4 || Date.now() < (value.nextAt || 0) || navigator.onLine === false) continue;
      let context = signedSignupContext(value.experimentContext) || storedAssignmentContext(value.assignment, value.createdAt);
      if (!context && value.legacyOwner) context = legacySignupContext({themeId:value.themeId,productId:value.productId,view:value.view,createdAt:value.submittedAt || value.createdAt});
      if (!context && continuesCurrentAssignment(value.assignment)) {
        for (const root of roots(document)) {
          const form = root.querySelector('form');
          let config;
          try { config = window.PinmeEmailInterests?.config(form); } catch (_) { continue; }
          if (config?.source !== value.source || config.topicType !== 'product' || config.topicId !== value.productId || config.purpose !== 'launch_notice') continue;
          context = pendingSignupContext({experimentContext:null,experimentAssignment:value.assignment,createdAt:value.createdAt}, form);
          if (context) break;
        }
      }
      if (!context) continue;
      if (value.assignment && context.experimentId !== value.assignment.experimentId) continue;
      value.experimentContext = context;
      // Persist only the confirmed receipt and original owner, never an email or auth.
      try { sessionStorage.setItem(analyticsPrefix + id, JSON.stringify(Object.fromEntries(Object.entries(value).filter(([key]) => !['attempts','nextAt'].includes(key))))); } catch (_) {}
      sendAnalyticsReceipt(id, value, context);
    }
    scheduleAnalyticsRecovery();
  }
  function sendAnalyticsReceipt(id, value, context) {
    if (!productionPage() || !analyticsAllowed() || analyticsFlights.has(id)) return;
    const controller = new AbortController(), refusalEpoch = analyticsRefusalEpoch;
    const timeout = setTimeout(() => controller.abort(), 7000);
    analyticsFlights.set(id, {controller,timeout}); value.attempts = (value.attempts || 0) + 1;
    const body = {experimentId:context.experimentId,token:context.token,receiptId:id,analyticsConsent:true,...(context.visitId ? {visitId:context.visitId} : {})};
    fetch(analyticsEndpoint + '/api/experiments/moonlit-offers/conversion', {method:'POST',mode:'cors',credentials:'omit',cache:'no-store',headers:{Accept:'application/json','Content-Type':'application/json'},body:JSON.stringify(body),signal:controller.signal}).then(async response => {
      const data = await response.json();
      if (!analyticsAllowed() || refusalEpoch !== analyticsRefusalEpoch || !analyticsReceipts.has(id)) return;
      if (response.ok && typeof data.recorded === 'boolean' && typeof data.converted === 'boolean' && (data.recorded || data.converted || data.duplicate === true || ['not_new_moonlit_interest','preview_ignored'].includes(data.status))) {
        removeAnalyticsReceipt(id);
        return;
      }
      if ([400,401,403,404,410,422].includes(response.status)) { removeAnalyticsReceipt(id); return; }
      throw Error('Receipt recovery retry');
    }).catch(() => {}).finally(() => {
      clearTimeout(timeout);
      const flight = analyticsFlights.get(id);
      if (flight?.controller === controller) analyticsFlights.delete(id);
      if (analyticsReceipts.has(id)) value.nextAt = Date.now() + analyticsRetryDelays[Math.min(3, value.attempts - 1)];
      scheduleAnalyticsRecovery();
    });
  }
  function queueAnalyticsReceipt(data, value, form, writeEvidence) {
    const originalProduction = value?.environment === 'production' && value.themeRole === 'main' && value.origin === location.origin;
    const legacyProduction = value?.environment === undefined && value.themeRole === undefined && value.origin === undefined && legacyMainThemes.has(value.themeId);
    if (!productionPage() || !(originalProduction || legacyProduction) || value.analyticsPermissionAtSubmit === false || writeEvidence?.analyticsPermissionAtWrite === false) return;
    let original = signedSignupContext(value.experimentContext);
    if (!Object.prototype.hasOwnProperty.call(value, 'experimentContext')) original = legacySignupContext(value);
    if (value.experimentContext !== null && Object.prototype.hasOwnProperty.call(value, 'experimentContext') && !original) return;
    const assignment = validAssignment(value.experimentAssignment, true) ? Object.fromEntries(['experimentId','variant','themeId','environment','expiresAt'].map(key => [key,value.experimentAssignment[key]])) : null;
    const legacyOwner = legacyProduction && !Object.prototype.hasOwnProperty.call(value, 'experimentContext');
    if (!original && !assignment && !legacyOwner) return;
    const receipt = {version:1,receiptId:data?.receiptId,createdAt:Date.now(),origin:location.origin,themeId:value.themeId,environment:'production',themeRole:'main',
      source:value.source,productId:value.productId,formId:form.id,path:value.path,view:value.view,assignment,experimentContext:original,analyticsPermissionAtSubmit:value.analyticsPermissionAtSubmit,legacyOwner,submittedAt:value.createdAt};
    if (!validAnalyticsReceipt(receipt) || analyticsPermission() === false) return;
    if (!analyticsReceipts.has(receipt.receiptId)) {
      while (analyticsReceipts.size >= 8) removeAnalyticsReceipt(analyticsReceipts.keys().next().value);
      analyticsReceipts.set(receipt.receiptId, receipt);
      analyticsTicks = 0;
      try { sessionStorage.setItem(analyticsPrefix + receipt.receiptId, JSON.stringify(receipt)); } catch (_) {}
    }
    flushAnalyticsReceipts();
  }
  const storageKey = (source, id) => storagePrefix + source + ':' + id;
  function removePending(key) { try { sessionStorage.removeItem(key); } catch (_) {} }
  function readPending(key, expected) {
    try {
      const value = JSON.parse(sessionStorage.getItem(key) || 'null');
      if (!value) return null;
      if (value.version !== 2 || !Number.isFinite(value.createdAt) || Date.now() - value.createdAt < 0 || Date.now() - value.createdAt > pendingLifetime || typeof value.email !== 'string' || value.email.length > 254 || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.email) || !/^[a-zA-Z0-9_-]{16,100}$/.test(value.nonce || '')) {
        removePending(key);
        return null;
      }
      if (Object.keys(expected).some(name => value[name] !== expected[name])) return null;
      return value;
    } catch (_) { removePending(key); return null; }
  }
  function writePending(key, value) {
    try { sessionStorage.setItem(key, JSON.stringify(value)); return true; }
    catch (_) { return false; }
  }
  function recoverPublishedPending(source, expected, url) {
    if (!productionPage() || !/^[a-zA-Z0-9_-]{16,100}$/.test(url.searchParams.get(returnParameter) || '')) return null;
    try {
      const candidates = [...Array(sessionStorage.length)].map((_, index) => sessionStorage.key(index)).filter(key => key?.startsWith(storagePrefix + source + ':'));
      for (const key of candidates) {
        const value = readPending(key, { source, productId: expected.productId, path: expected.path, view: expected.view });
        if (!value || url.hash !== '#' + value.formId || url.searchParams.get(returnParameter) !== value.nonce) continue;
        if (key !== storageKey(source, value.formId) || !String(value.formId).startsWith('PinmeMoonlitSignup-')) continue;
        const recordedProduction = value.themeRole === 'main' && value.environment === 'production' && value.origin === location.origin;
        const verifiedLegacyProduction = value.themeRole === undefined && value.environment === undefined && value.origin === undefined && legacyMainThemes.has(value.themeId);
        if (recordedProduction || verifiedLegacyProduction) return { key, value };
      }
    } catch (_) {}
    return null;
  }
  function cleanExpired() {
    try {
      [...Array(sessionStorage.length)].map((_, index) => sessionStorage.key(index)).filter(key => key?.startsWith(storagePrefix)).forEach(key => readPending(key, {}));
    } catch (_) {}
  }
  function initialize(root) {
    if (controllers.has(root)) return;
    const form = root.querySelector('form');
    const email = form?.querySelector('[name="contact[email]"]');
    const button = form?.querySelector('[type="submit"]');
    const marker = form?.querySelector('[data-newsletter-status]');
    if (!form || !email || !button || !marker) return;
    const source = root.dataset.signupSource;
    const expected = { source, formId: form.id, productId: root.dataset.signupProduct, path: location.pathname, view: new URL(location.href).searchParams.get('view') || '', themeId: themeIdentity() };
    let key = storageKey(source, form.id);
    const abort = new AbortController();
    const error = form.querySelector('[data-newsletter-field-error]');
    const retry = form.querySelector('[data-newsletter-verify]');
    const idleLabel = button.dataset.idleLabel || button.textContent;
    button.setAttribute('aria-live', 'polite');
    const unavailable = button.disabled || !/^\d+$/.test(root.dataset.signupProduct || '');
    const serverResult = marker.closest('form') === form && marker.dataset.moonlitSignupMessage === source ? marker.dataset.newsletterResult : null;
    const serverMessage = marker.textContent.trim();
    const initialReturn = form.querySelector('[name="return_to"]')?.value;
    let pendingEntry = readPending(key, expected);
    if (pendingEntry?.environment && pendingEntry.environment !== pendingEnvironment().environment) pendingEntry = null;
    if (pendingEntry && productionPage() && !pendingEntry.environment && !legacyMainThemes.has(pendingEntry.themeId)) pendingEntry = null;
    if (!pendingEntry) {
      const recovered = recoverPublishedPending(source, expected, new URL(location.href));
      if (recovered) { key = recovered.key; pendingEntry = recovered.value; }
    }
    let nativeConfirmed = false;
    let recording = null;
    let dependencyWait = false;
    const context = () => window.PinmeEmailInterests?.config(form);
    function setState(state, message = '') {
      root.dataset.signupState = state;
      root.dataset.signupNativeConfirmed = String(nativeConfirmed);
      form.dataset.newsletterState = nativeConfirmed ? 'success' : state;
      form.removeAttribute('aria-busy');
      email.readOnly = nativeConfirmed;
      button.disabled = nativeConfirmed || unavailable;
      button.textContent = decodeMessage(nativeConfirmed ? button.dataset.joinedLabel || idleLabel : idleLabel);
      marker.hidden = !message || state === 'success';
      marker.textContent = decodeMessage(message);
      marker.classList.toggle('is-success', nativeConfirmed);
      marker.classList.toggle('is-error', state === 'error');
      marker.setAttribute('role', state === 'error' ? 'alert' : 'status');
      marker.setAttribute('aria-live', state === 'error' ? 'assertive' : 'polite');
      if (retry) {
        retry.hidden = state !== 'preferences';
        retry.disabled = Boolean(recording);
        retry.textContent = decodeMessage(context()?.labels?.retry || idleLabel);
      }
    }
    function clearReturn() {
      const url = new URL(location.href);
      if (pendingEntry && url.searchParams.get(returnParameter) === pendingEntry.nonce) {
        url.searchParams.delete(returnParameter);
        history.replaceState(history.state, '', url.href);
      }
      removePending(key);
      pendingEntry = null;
    }
    function recordPreference() {
      if (!nativeConfirmed || !pendingEntry || recording) return;
      if (!window.PinmeEmailInterests) {
        if (document.readyState !== 'complete') {
          if (!dependencyWait) {
            dependencyWait = true;
            const resume = () => { if (window.PinmeEmailInterests || document.readyState === 'complete') recordPreference(); };
            document.addEventListener('DOMContentLoaded', resume, { once: true, signal: abort.signal });
            window.addEventListener('load', resume, { once: true, signal: abort.signal });
          }
          return;
        }
        setState('success', marker.dataset.successMessage);
        return;
      }
      if (retry) retry.disabled = true;
      const originalPending = pendingEntry;
      const refusalEpoch = analyticsRefusalEpoch;
      let refused = originalPending.analyticsPermissionAtSubmit === false || analyticsPermission() === false;
      let writeEvidence = null;
      const observedWrite = event => {
        const value = event.detail;
        if (value?.formId === form.id && value.source === source && value.topicType === 'product' && value.topicId === originalPending.productId && value.purpose === 'launch_notice') writeEvidence = value;
      };
      document.addEventListener('pinme:interest-recorded', observedWrite);
      const resolveOriginalContext = () => {
        if (analyticsPermission() === false || refusalEpoch !== analyticsRefusalEpoch) refused = true;
        return refused ? null : pendingSignupContext(originalPending, form);
      };
      recording = window.PinmeEmailInterests.record(form, { signal: abort.signal, experimentContext:resolveOriginalContext }).then(data => {
        if (abort.signal.aborted) return;
        if (!refused && refusalEpoch === analyticsRefusalEpoch) {
          try { queueAnalyticsReceipt(data, originalPending, form, writeEvidence); } catch (_) { /* Optional linkage never changes a saved signup. */ }
        }
        clearReturn();
        setState('success', marker.dataset.successMessage);
      }).catch(() => {
        if (!abort.signal.aborted) setState('preferences', context()?.labels?.preferencesError || marker.dataset.successMessage);
      }).finally(() => { document.removeEventListener('pinme:interest-recorded', observedWrite); recording = null; if (retry) retry.disabled = false; });
    }
    function prepareReturn() {
      if (nativeConfirmed || unavailable || !form.checkValidity()) return;
      ['pinme_form_return_source', 'pinme_form_return_scroll_x', 'pinme_form_return_scroll_y', 'pinme_form_return_time', 'pinme_newsletter_source', 'pinme_newsletter_return_email'].forEach(removePending);
      const value = email.value.trim();
      key = storageKey(source, form.id);
      const current = readPending(key, expected);
      let experimentContext = null;
      try { if (analyticsAllowed()) experimentContext = signedSignupContext(window.PinmeMoonlitExperimentCollector?.signupContext?.(context(), form)); } catch (_) {}
      // Reading the already rendered routing choice is not an analytics grant.
      // An unknown API may resolve later; an explicit refusal remains a refusal.
      const experimentAssignment = assignmentIntent(true);
      const analyticsPermissionAtSubmit = analyticsPermission();
      pendingEntry = current?.email === value ? { ...current, ...pendingEnvironment(), experimentContext, experimentAssignment, analyticsPermissionAtSubmit } : { version: 2, ...expected, ...pendingEnvironment(), experimentContext, experimentAssignment, analyticsPermissionAtSubmit, email: value, nonce: crypto.randomUUID(), createdAt: Date.now() };
      const stored = writePending(key, pendingEntry);
      const destination = new URL(location.href);
      ['customer_posted', 'contact_posted', returnParameter].forEach(name => destination.searchParams.delete(name));
      destination.searchParams.set('customer_posted', 'true');
      if (stored) destination.searchParams.set(returnParameter, pendingEntry.nonce);
      const theme = window.Shopify?.theme;
      if (['unpublished', 'development'].includes(theme?.role) && /^\d+$/.test(String(theme.id))) destination.searchParams.set('preview_theme_id', String(theme.id));
      else if (theme?.role === 'main') destination.searchParams.delete('preview_theme_id');
      else {
        const preview = new URL(initialReturn || location.href, location.href).searchParams.get('preview_theme_id');
        if (/^\d+$/.test(preview || '')) destination.searchParams.set('preview_theme_id', preview);
      }
      destination.hash = form.id;
      let returnTo = form.querySelector('[name="return_to"]');
      if (!returnTo) { returnTo = document.createElement('input'); returnTo.type = 'hidden'; returnTo.name = 'return_to'; form.append(returnTo); }
      returnTo.value = destination.pathname + destination.search + destination.hash;
    }
    form.addEventListener('submit', prepareReturn, { capture: true, passive: true, signal: abort.signal });
    email.addEventListener('input', () => {
      if (nativeConfirmed) return;
      email.removeAttribute('aria-invalid');
      if (error) error.hidden = true;
      setState('idle');
    }, { signal: abort.signal });
    retry?.addEventListener('click', recordPreference, { signal: abort.signal });
    const controller = { form, destroy() { abort.abort(); controllers.delete(root); } };
    controllers.set(root, controller);
    const url = new URL(location.href);
    const returnedToForm = url.hash === '#' + form.id || Boolean(pendingEntry && url.hash === '#' + pendingEntry.formId && url.searchParams.get(returnParameter) === pendingEntry.nonce);
    const matchesPending = returnedToForm && pendingEntry && url.searchParams.get(returnParameter) === pendingEntry.nonce;
    setState('idle');
    if (returnedToForm && serverResult === 'error') {
      if (matchesPending) email.value = pendingEntry.email;
      removePending(key);
      pendingEntry = null;
      setState('error', serverMessage || marker.dataset.errorMessage);
      email.setAttribute('aria-invalid', 'true');
    } else if (returnedToForm && serverResult === 'success') {
      nativeConfirmed = true;
      setState('success', serverMessage || marker.dataset.successMessage);
      if (matchesPending) { email.value = pendingEntry.email; recordPreference(); }
    }
  }
  function init(scope = document) { cleanExpired(); roots(scope).forEach(initialize); }
  function destroy(scope) {
    controllers.forEach((controller, root) => {
      if (scope === root || scope.contains(root)) controller.destroy();
    });
  }
  window.PinmeMoonlitSignup = { init, destroy };
  document.addEventListener('pinme:moonlit-receipt-handled', event => {
    const value = analyticsReceipts.get(event.detail?.receiptId);
    const owner = signedSignupContext(value?.experimentContext);
    if (value && owner && event.detail.experimentId === owner.experimentId && event.detail.exposureId === owner.token.split('.')[1]) removeAnalyticsReceipt(value.receiptId);
  });
  const resumeAnalytics = () => { restoreAnalyticsReceipts(); flushAnalyticsReceipts(); scheduleAnalyticsRecovery(true); };
  document.addEventListener('visitorConsentCollected', () => { if (analyticsPermission() === false) analyticsRefusalEpoch++; resumeAnalytics(); });
  document.addEventListener('pinme:moonlit-assigned', resumeAnalytics);
  document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') resumeAnalytics(); });
  window.addEventListener('load', resumeAnalytics, {once:true});
  window.addEventListener('pageshow', resumeAnalytics);
  resumeAnalytics();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => destroy(event.target));
  window.addEventListener('pageshow', () => init());
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
})();
